export default {
  methods: {
    hasPermission(resource, action) {
      let has = false;
      if (resource == null || resource === '') {
        has = true;
      } else {
        let resourcesStr = localStorage.getItem('resources');
        if (resourcesStr === null || resourcesStr === '') {
          console.warn('LocalStorage resources is empty.');
        } else {
          let resources = JSON.parse(resourcesStr);
          if (resources.hasOwnProperty(resource)) {
            if (action == null) {
              has = true;
            } else {
              let permission = parseInt(resources[resource]);
              action = parseInt(action);
              has = (permission & action) === action;
            }
          }
        }
      }
      return has;
    }
  }
}
